var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cp-project-list" }, [
    _c(
      "div",
      { staticClass: "teq-container" },
      [
        _c(
          "div",
          { staticClass: "filters" },
          _vm._l(_vm.projectFilters.filters, function(filter, index) {
            return _c(
              "teq-custom-select",
              {
                key: index,
                attrs: {
                  name: filter.name,
                  options: filter.list,
                  "option-keys": ["value", "label"],
                  placeholderOption: "true",
                  selectedValue: _vm.selectedValueFor(filter.name)
                },
                on: { input: _vm.resultChange },
                model: {
                  value: _vm.filters[filter.name],
                  callback: function($$v) {
                    _vm.$set(_vm.filters, filter.name, $$v)
                  },
                  expression: "filters[filter.name]"
                }
              },
              [
                _c(
                  "option",
                  {
                    staticClass: "disabled",
                    attrs: {
                      slot: "additionalOption",
                      value: "",
                      selected: "",
                      disabled: ""
                    },
                    slot: "additionalOption"
                  },
                  [_vm._v(_vm._s(filter.title))]
                )
              ]
            )
          }),
          1
        ),
        _vm._v(" "),
        _vm.loading ? _c("div", { staticClass: "loader" }) : _vm._e(),
        _vm._v(" "),
        !_vm.results
          ? _c("div", { staticClass: "no-results-msg" }, [
              _vm._v(_vm._s(_vm.dataProject.error_msg))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.dataProject
          ? _c(
              "div",
              { staticClass: "results" },
              [
                _vm._l(_vm.chunkedList, function(projects, chunkedIndex) {
                  return [
                    _c(
                      "div",
                      { staticClass: "clearfix" },
                      _vm._l(projects, function(project, index) {
                        return _c("div", { key: index, staticClass: "item" }, [
                          _c("img", {
                            staticClass: "illust",
                            attrs: {
                              src: project.url_img,
                              alt: project.alt_img
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "-content" }, [
                            _c("div", { staticClass: "subtitle" }, [
                              _vm._v(_vm._s(project.subtitle))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "title" }, [
                              _vm._v(_vm._s(project.title))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "hidden" }, [
                              _c("div", { staticClass: "structure" }, [
                                _vm._v(_vm._s(project.structure))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "city" }, [
                                _vm._v(_vm._s(project.city))
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("a", {
                            staticClass: "link",
                            attrs: { href: project.url_project }
                          })
                        ])
                      }),
                      0
                    )
                  ]
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.dataProject
          ? _c("paginate", {
              attrs: {
                "page-count": _vm.dataProject.page_total,
                "page-range": 3,
                "click-handler": _vm.clickCallback,
                "prev-text": "",
                "next-text": "",
                "prev-link-class": "prev",
                "next-link-class": "next",
                "container-class": "pagination",
                "page-class": "page-item"
              },
              model: {
                value: _vm.page,
                callback: function($$v) {
                  _vm.page = $$v
                },
                expression: "page"
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }